"use client"

import { useEffect } from "react"
import { RECENTLY_VIEWED_PRODUCTS_COOKIE_NAME, RECENTLY_VIEWED_PRODUCTS_SEPARATOR } from "@/constants"
import Cookies from "js-cookie"

function addToRecentlyViewedProductsClient(productId: string, limit: number = 10) {
  const recentlyViewedProductsCookieValue = Cookies.get(RECENTLY_VIEWED_PRODUCTS_COOKIE_NAME)
  let recentlyViewedProducts = recentlyViewedProductsCookieValue
    ? recentlyViewedProductsCookieValue.split(RECENTLY_VIEWED_PRODUCTS_SEPARATOR)
    : []

  recentlyViewedProducts = recentlyViewedProducts.filter((id) => {
    return id !== productId
  })

  recentlyViewedProducts.unshift(productId)
  recentlyViewedProducts = recentlyViewedProducts.slice(0, limit)

  const recentlyViewedProductsNew = recentlyViewedProducts.join(RECENTLY_VIEWED_PRODUCTS_SEPARATOR)
  //console.log("Set recentlyViewedProductsNew", recentlyViewedProducts)
  Cookies.set(RECENTLY_VIEWED_PRODUCTS_COOKIE_NAME, recentlyViewedProductsNew, {
    path: "/",
    secure: true,
    sameSite: "none",
  })
}

/*Tracks visits to PDPs in a cookie*/
export default function PdpRecentlyViewedTrackingClient({ productId }: { productId: string }) {
  useEffect(() => {
    addToRecentlyViewedProductsClient(productId, 8)
  }, [productId])
  return <></>
}
